<div class="modal fade" id="modal_add_delivery" tabindex="-1" role="dialog" aria-labelledby="addDeliveryTitle"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addDeliveryTitle">
                    <fa-icon [icon]="icons.faTruck"></fa-icon>
                    Add New Delivery
                </h5>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                    <fa-icon [icon]="icons.faTimes"></fa-icon>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-check">
                        <input class="form-check-input" #in_store type="checkbox" id="inStore">
                        <label class="form-check-label" for="inStore">Customer In Store?</label>
                    </div>
                    <div class="form-group">
                        <label for="year">Vehicle Year</label>
                        <input type="number" class="form-control" #year id="year" placeholder="e.g., 2024">
                    </div>
                    <div class="form-group">
                        <label for="model">Vehicle Model</label>
                        <input type="text" class="form-control" #model id="model" placeholder="e.g., Honda Civic">
                    </div>
                    <div class="form-group">
                        <label for="color">Vehicle Color</label>
                        <input type="text" class="form-control" #color id="color" placeholder="e.g., Silver">
                    </div>
                    <div class="form-group">
                        <label for="stock_number">Stock Number</label>
                        <input type="text" class="form-control" #stock_number id="stock_number" placeholder="e.g., STK-12345">
                    </div>

                    <div class="form-group">
                        <label for="salesman">Salesman</label>
                        <select class="form-select" #salesman id="salesman">
                            <option selected disabled>Select a salesman</option>
                            <option *ngFor="let emp of salesmen" [value]="emp.name">{{ emp.name }}</option>
                        </select>
                    </div>

                    <div class="form-group" [ngClass]="{ 'invisible': in_store.checked }">
                        <label for="arrival_time">Arrival Time</label>
                        <input type="datetime-local" class="form-control" #time id="arrival_time" step="900">
                    </div>
                    <div *ngIf="modal_error" class="alert alert-danger" role="alert">
                        <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                        {{ modal_error }}
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                    (click)="modal_error=undefined;" aria-label="Cancel">
                    <fa-icon [icon]="icons.faTimes"></fa-icon>
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" 
                    (click)="addDelivery({
                        id: 'new',
                        customer_in_store: in_store.checked,
                        arrival_time: strToMoment(time.value),
                        stock_number: stock_number.value,
                        vehicle: {
                            color: color.value,
                            model: model.value,
                            year: strToInt(year.value)
                        },
                        emp: salesman.value
                    });
                    in_store.checked = false;
                    time.value = '';
                    stock_number.value = '';
                    color.value = '';
                    model.value = '';
                    year.value = '';
                    salesman.value = '';
                    "
                    aria-label="Add Delivery">
                    <fa-icon [icon]="icons.faPlus"></fa-icon>
                    Add Delivery
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="modal_edit_delivery" tabindex="-1" role="dialog" aria-labelledby="editDeliveryTitle"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editDeliveryTitle">
                    <fa-icon [icon]="icons.faEdit"></fa-icon>
                    Edit Delivery
                </h5>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                    <fa-icon [icon]="icons.faTimes"></fa-icon>
                </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-check">
                        <input class="form-check-input" #edit_in_store type="checkbox" id="edit_inStore"
                            [checked]="curDelivery?.customer_in_store" (change)="setArrivingNow(edit_in_store.checked)">
                        <label class="form-check-label" for="edit_inStore">Customer In Store?</label>
                    </div>
                    <div class="form-group">
                        <label for="edit_year">Vehicle Year</label>
                        <input type="number" class="form-control" #edit_year id="edit_year"
                            [value]="curDelivery?.vehicle?.year">
                    </div>
                    <div class="form-group">
                        <label for="edit_model">Vehicle Model</label>
                        <input type="text" class="form-control" #edit_model id="edit_model"
                            [value]="curDelivery?.vehicle?.model">
                    </div>
                    <div class="form-group">
                        <label for="edit_color">Vehicle Color</label>
                        <input type="text" class="form-control" #edit_color id="edit_color"
                            [value]="curDelivery?.vehicle?.color">
                    </div>
                    <div class="form-group">
                        <label for="edit_stock_number">Stock Number</label>
                        <input type="text" class="form-control" #edit_stock_number id="edit_stock_number"
                            [value]="curDelivery?.stock_number">
                    </div>

                    <div class="form-group">
                        <label for="edit_salesman">Salesman</label>
                        <select class="form-select" #edit_salesman id="edit_salesman">
                            <option *ngFor="let emp of salesmen" [value]="emp.name"
                                [selected]="curDelivery?.emp == emp.name">{{ emp.name }}</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="edit_arrival_time">Arrival Time</label>
                        <input type="datetime-local" class="form-control" #edit_time id="edit_arrival_time" step="900">
                    </div>
                    <div *ngIf="modal_error" class="alert alert-danger" role="alert">
                        <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                        {{ modal_error }}
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modal_error=undefined;
                             curDelivery = undefined;" aria-label="Cancel">
                    <fa-icon [icon]="icons.faTimes"></fa-icon>
                    Cancel
                </button>
                <button type="button" class="btn btn-primary"
                    (click)="saveDelivery(edit_in_store.checked, edit_stock_number.value, strToMoment(edit_time.value), edit_color.value, edit_model.value, strToInt(edit_year.value), edit_salesman.value)"
                    aria-label="Save Changes">
                    <fa-icon [icon]="icons.faSave"></fa-icon>
                    Save
                </button>
            </div>
        </div>
    </div>
</div>
<div *ngIf="boardPermissions.userHasEditPermissions(boardPermissions.boardUser) && showDelivery">
    <div class="delivery-container">
        <div class="delivery-header">
            <h1 class="delivery-title">
                <fa-icon [icon]="icons.faTruck"></fa-icon>
                Manage Deliveries
            </h1>
            <p class="delivery-subtitle">View, add, and manage customer deliveries and scheduled arrivals</p>
        </div>

        <table class="delivery-table table">
            <thead>
                <tr>
                    <th style="width: 5%; text-align: left;">Actions</th>
                    <th style="width: 15%; text-align: left;">Priority</th>
                    <th style="width: 10%;">Year</th>
                    <th style="width: 15%;">Model</th>
                    <th style="width: 12%;">Color</th>
                    <th style="width: 15%;">Stock #</th>
                    <th style="width: 15%;">Salesman</th>
                    <th style="width: 12%;">Timer</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let delivery of sort(deliveries)" [ngClass]="{
                        'table-success': timeUtils.isOnSchedule(delivery, now),
                        'table-warning': timeUtils.isWarning(delivery, now),
                        'table-danger': timeUtils.isAlert(delivery, now)
                    }">
                    <td>
                        <div style="display: flex; gap: 0.5rem;">
                            <button type="button" class="btn btn-secondary" title="Edit Delivery"
                                aria-label="Edit delivery"
                                (click)="editDelivery(delivery)">
                                <fa-icon [icon]="icons.faEdit"></fa-icon>
                            </button>
                            <button type="button" class="btn btn-danger" title="Remove Delivery"
                                aria-label="Remove delivery"
                                (click)="removeDelivery(delivery)">
                                <fa-icon [icon]="icons.faTrash"></fa-icon>
                            </button>
                        </div>
                    </td>
                    <td>
                        <strong>
                            {{
                                delivery.customer_in_store
                                ? 'Here'
                                : delivery.arrival_time > now
                                ? 'Arriving in ' + timeUtils.arrivingInStr(delivery.arrival_time, now)
                                : timeUtils.arrivingInStr(delivery.arrival_time, now) + ' late'
                            }}
                        </strong>
                    </td>
                    <td>{{ delivery.vehicle?.year }}</td>
                    <td>{{ delivery.vehicle?.model }}</td>
                    <td>{{ delivery.vehicle?.color }}</td>
                    <td><code>{{ delivery.stock_number }}</code></td>
                    <td>{{ delivery.emp }}</td>
                    <td>
                        {{
                            delivery.customer_in_store
                            ? timeUtils.inStoreForStr(delivery.arrival_time, now)
                            : '-'
                        }}
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="delivery-legend">
            <div class="legend-section">
                <h4>
                    <fa-icon [icon]="icons.faClock"></fa-icon>
                    Legend: Customer In Store
                </h4>
                <table class="legend-table">
                    <tr class="table-success">
                        <td>
                            <fa-icon [icon]="icons.faCheckCircle"></fa-icon>
                            Customer in store less than 5 minutes
                        </td>
                    </tr>
                    <tr class="table-warning">
                        <td>
                            <fa-icon [icon]="icons.faExclamationTriangle"></fa-icon>
                            Customer in store between 5 - 10 minutes
                        </td>
                    </tr>
                    <tr class="table-danger">
                        <td>
                            <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                            Customer in store more than 10 minutes
                        </td>
                    </tr>
                </table>
            </div>

            <div class="legend-section">
                <h4>
                    <fa-icon [icon]="icons.faCalendarAlt"></fa-icon>
                    Legend: Scheduled Arrival
                </h4>
                <table class="legend-table">
                    <tr class="table-success">
                        <td>
                            <fa-icon [icon]="icons.faCheckCircle"></fa-icon>
                            Customer arriving in more than 1 hour 15 minutes
                        </td>
                    </tr>
                    <tr class="table-warning">
                        <td>
                            <fa-icon [icon]="icons.faExclamationTriangle"></fa-icon>
                            Customer arriving in less than 1 hour 15 minutes
                        </td>
                    </tr>
                    <tr class="table-danger">
                        <td>
                            <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                            Customer arriving in less than 45 minutes
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div style="margin-top: 2rem;">
            <button type="button" class="btn btn-success btn-lg" title="Add New Delivery" 
                data-toggle="modal" data-target="#modal_add_delivery" aria-label="Add new delivery">
                <fa-icon [icon]="icons.faPlus"></fa-icon>
                Add New Delivery
            </button>
        </div>
    </div>
</div>

<div *ngIf="!boardPermissions.userHasEditPermissions(boardPermissions.boardUser)" class="delivery-container">
    <div class="auth-error-container">
        <h1>
            <fa-icon [icon]="icons.faLock"></fa-icon>
            403 - Not Authorized
        </h1>
        <p>You do not have permission to manage deliveries on this board.</p>
    </div>
</div>

